export const environment = {
    production: true,
    api: 'https://feature41741.api.classichub.co.nz',
    buildVersion: '2026.10.30.1',
    uri: 'https://feature41741.classichub.co.nz',
    envName: 'feature41741',
    isTest: true,
};

